var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNounBoatLaunch2003B6Bf9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#87C9ED",
    d: "m652.39 761.85c48.648-11.148 84.898-54.684 84.898-106.7 0-60.434-48.996-109.43-109.45-109.43-60.469 0-109.46 48.996-109.46 109.43 0 35.125 16.535 66.395 42.266 86.41l-560.64-123.9v295.54l613.99 0.42188c27.574 0 51.805-14.387 65.605-36.035 13.789 21.648 38.004 36.035 65.617 36.035 27.59 0 51.805-14.387 65.629-36.035 13.777 21.648 38.004 36.035 65.605 36.035 27.574 0 51.816-14.387 65.617-36.035 13.789 21.648 38.004 36.035 65.605 36.035s51.828-14.387 65.617-36.035c13.777 21.648 38.027 36.035 65.617 36.035 24.793 0 46.871-11.617 61.129-29.699zm-81.801-106.71c0-31.598 25.633-57.227 57.254-57.227 31.633 0 57.254 25.633 57.254 57.227 0 31.633-25.621 57.266-57.254 57.266-31.613 0-57.254-25.633-57.254-57.266z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87C9ED",
    d: "m1115.8 722-367.44-79.922c0.46875 4.3086 0.69531 8.6523 0.69531 13.066 0 10.754-1.4023 21.133-3.9961 31.02l361.45 78.613 9.2891-42.777"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87C9ED",
    d: "m54.492 491.14-9.3125 42.781 463.15 100.75c2.5312-14.941 7.8242-28.934 15.312-41.484l-469.15-102.05"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87C9ED",
    d: "m403.77 381.39 126.39-71.566-13.262-23.438-152.68 86.461-251.69-54.457c1.7031 156.61 173.45 202.05 173.45 202.05l251.73 53.629c22.199-24.66 54.359-40.141 90.133-40.141 53.941 0 99.66 35.23 115.39 83.941l317.4 67.609 79.141-144.83-736.02-159.27"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounBoatLaunch2003B6Bf9);
export default __webpack_public_path__ + "static/media/noun-boat-launch-200-3B6BF9.37aab4b5163bc82c4cf8fe3c33a9aa39.svg";
export { ForwardRef as ReactComponent };